export default "__VITE_ASSET__72f1927d__"